module.exports = __webpack_public_path__ + "img/water3-1.19868791.jpg";